var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapjobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.404 3.70087C9.58907 3.79335 9.79312 3.84149 10 3.84149C10.2069 3.84149 10.4109 3.79335 10.596 3.70087L13.0353 2.48087C13.1371 2.43004 13.2501 2.40608 13.3637 2.41125C13.4773 2.41642 13.5876 2.45056 13.6843 2.51043C13.781 2.57029 13.8607 2.65388 13.916 2.75326C13.9713 2.85264 14.0002 2.9645 14 3.0782V11.5875C13.9999 11.7113 13.9654 11.8326 13.9003 11.9379C13.8352 12.0432 13.7421 12.1282 13.6313 12.1835L10.596 13.7015C10.4109 13.794 10.2069 13.8422 10 13.8422C9.79312 13.8422 9.58907 13.794 9.404 13.7015L6.596 12.2975C6.41094 12.2051 6.20689 12.1569 6 12.1569C5.79312 12.1569 5.58907 12.2051 5.404 12.2975L2.96467 13.5175C2.8629 13.5684 2.74982 13.5924 2.63617 13.5872C2.52253 13.5819 2.41211 13.5477 2.31541 13.4878C2.21872 13.4279 2.13898 13.3442 2.08377 13.2447C2.02856 13.1452 1.99972 13.0333 2 12.9195V4.41087C2.00007 4.2871 2.03459 4.16578 2.0997 4.06052C2.16482 3.95526 2.25795 3.8702 2.36867 3.81487L5.404 2.29687C5.58907 2.20439 5.79312 2.15625 6 2.15625C6.20689 2.15625 6.41094 2.20439 6.596 2.29687L9.404 3.70087Z",
    stroke: "#6B7280",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.84375V13.8438",
    stroke: "#6B7280",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.15625V12.1563",
    stroke: "#6B7280",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapjobs);
export default __webpack_public_path__ + "static/media/Map jobs.149e14c06aaf2dcc3e6e61c0632a5501.svg";
export { ForwardRef as ReactComponent };